import { useMemo } from 'preact/hooks'
import isBoolean from 'lodash-es/isBoolean'

import NextLinkWrapper from './components/router/link'
import { LinkProvider } from './components/atom/link-wrapper'
import { SmartImgSettingsProvider } from './components/atom/nbb-smart-img'
import { PATHS } from './config'
import HorizontalThirdsTemplate from './components/template/HorizontalThirds'
import HorizontalHalvesTemplate from './components/template/HorizontalHalves'
import { SiteHeaderImagesProvider } from './components/organism/SiteHeader/header-image/provider'
import CookieDisclaimer from './components/organism/cookie-disclaimer'
import CFBeacon from './components/atom/cf-beacon'
import HERO_IMAGES from './components/organism/SiteHeader/header-image/crawler'
import { PageContextProvider } from './components/router/page-context'

import '@fontsource/roboto-condensed'
import 'normalize.css/normalize.css'
import '../css/00_base/index.scss'

export function BlogApp({ pageContext }) {
  const {
    config,
    pageProps,
    errorWhileRendering,
  } = pageContext

  const {
    Page,
    Footer,
  } = config

  const [Template, FooterComponent] = useMemo(
    () => {
      const FooterComponent = getFooterComponent(Footer)

      const Template = FooterComponent !== false
        ? HorizontalThirdsTemplate
        : HorizontalHalvesTemplate

      return [
        Template,
        isBoolean(FooterComponent)
          ? undefined
          : FooterComponent,
      ]
    },
    [Footer],
  )

  return (
    <PageContextProvider pageContext={pageContext}>
      <SmartImgSettingsProvider>
        <LinkProvider value={NextLinkWrapper}>
          <SiteHeaderImagesProvider images={HERO_IMAGES}>
            <Template
              className="main-content"
              footer={FooterComponent && <FooterComponent {...pageProps} />}
              pageProps={pageProps}
            >
              <Page error={errorWhileRendering} {...pageProps} />
            </Template>

            <CookieDisclaimer link={PATHS.COOKIE_POLICY} />
          </SiteHeaderImagesProvider>
        </LinkProvider>

        <CFBeacon token={import.meta.env?.VITE_CF_TOKEN} />
      </SmartImgSettingsProvider>
    </PageContextProvider>
  )
}

function getFooterComponent(Footer) {
  const footerDisabled = Footer === false
  const footerEnabled = Footer === true

  if (footerDisabled) {
    return false
  }

  if (footerEnabled || !Footer) {
    return true
  }

  return Footer
}

